import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Travel } from 'src/app/models/travel';
import { User } from 'src/app/models/user';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { PURPOSE } from 'src/app/modules/shared/common/api';
import { TravelService } from '../../services/travel/travel.service';
import { AuthService } from 'src/app/modules/login/services/auth/auth.service';
import { TravelAuthorizationCancelComponent } from '../travel-authorization-cancel/travel-authorization-cancel.component';
import { TravelItineraryViewComponent } from 'src/app/modules/shared/components/travel-itinerary-view/travel-itinerary-view.component';
import { FunctionsService } from 'src/app/modules/shared/services/functions.service';
import { NotifyboxComponent } from 'src/app/modules/shared/components/notifybox/notifybox.component';

@Component({
  selector: 'app-travel-approver-view',
  templateUrl: './travel-approver-view.component.html',
  styleUrls: ['./travel-approver-view.component.scss']
})
export class TravelApproverViewComponent implements OnInit {

  
  formGroup: FormGroup;
  objectKeys = Object.keys;

  detail: Travel;
  selectedIndex = 0;
  asn:boolean = false;
  IsASN:boolean = false;
  loading:boolean = false;
  isCurrency:boolean = false;
  isCharged:boolean = false;
  show:boolean = false;
  isOther:boolean = false;
  travel: Travel;
  _user: User;
  successMessage = '';
  labelName = '';
  qty = {};
  pipe = new DatePipe('en-US');

  fDate:any;
  tDate:any;
  dialogConfig:any;
  departmentList = JSON.parse(localStorage.getItem('department'));
  positionList = JSON.parse(localStorage.getItem('position'));
  itineraryId:any;
  expensesList:any;
  itineraries:any;
  isSpecialApprover:boolean = false;
  isFirstSpecialApprover:boolean = false;
  isNotFirstApprover:boolean = false;
  isFirstApprover:boolean = false;

  travelOption = ["Individual","Group"];
  purposeOption = PURPOSE;
  natureOption = ["Inbound","Outbound"];
  currencyOption = [
    {id:1,name:"PHP"},
    {id:2,name:"USD"},
    {id:3,name:"Others"}
  ];
  chargeOption = [
    {id:1,name:"Rose Pharmacy"},
    {id:2,name:"DF"},
    {id:3,name:"Supplier"},
    {id:4,name:"RRHI"},
    {id:5,name:"Southstar Drug"}
  ];

  statusOption={
    3 : 'Approved',
    4 : 'Rejected',
    5 : 'Cancelled'
  };

  bookedOption = ["Office Booking","Self Booking"];
  billOption = ["Store Support Center","Requestor"];

  constructor(
    public dialogRef: MatDialogRef<TravelApproverViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public travelService: TravelService,
    public authService: AuthService,
    public functionService: FunctionsService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.detail = this.data.res;
    this._user = new User(this.authService.getAuthUser());
    this.formGroup = this.formBuilder.group({
      date_filed:['',null],
      itinerary_date: ['',null],
      travel_authorization_no: ['',null],
      travel_authorization_id: ['',null],
      complete_name:['',null],
      employee_id_no: ['',null],
      position: ['',null],
      area_covered: ['',null],
      payroll_acct_no: ['',null],
      copy_date: ['',null],
      nature: ['',null],
      representation:['',null],
      miscellaneous:['',null],
      amount: ['',null],
      booked_by: ['',null],
      bill_to: ['',null],
      is_draft: ['',null],
      accommodation_cost: ['',null],
      travel_itinerary_details:['',null],
      is_lunch:['',null],
      is_dinner:['',null],
      is_breakfast: ['',null],
      meal:['',null],
      per_diem:['',null],
      others:['',null],

      // Version 1.5

      // Header Info
      travel_request_type:['',null],
      employee_name:['',null],
      employee_id: ['',null],
      level:['',null],
      department: ['',null],
      area_assigned:['',null],
      travel_type: ['',null],
      purpose: ['',null],
      location: ['',null],
      booking_type: ['',null],
      booking_type_itinerary: ['',null],
      inclusive_date_from: ['',null],
      inclusive_date_to: ['',null],
      currency: ['',null],
      currency_category: ['',null],
      charged_to_category: ['',null],
      charged_to: ['',null],
    });
    this.travel = new Travel(this.data.res);
    this.travel.summary_list = this.data.res.travel_summary.travel_summary_details;
    this.travel.booking_details_list = this.data.res.travel_booking_details;
    this.formGroup.controls['area_covered'].setValue(this.data.res.area_covered);
    this.formGroup.controls['amount'].setValue(this.data.res.travel_summary.amount);
    this.formGroup.controls['bill_to'].setValue(this.data.res.travel_summary.bill_to);
    this.formGroup.controls['position'].setValue(this.data.res.position);
    this.formGroup.controls['department'].setValue(this.data.res.department);
    this.formGroup.controls['payroll_acct_no'].setValue(this.data.res.payroll_acct_no);
    this.formGroup.controls['booked_by'].setValue(this.data.res.travel_summary.booked_by);
    this.formGroup.controls['charged_to'].setValue(this.data.res.travel_summary.charged_to);
    this.formGroup.controls['currency'].setValue(this.data.res.travel_summary.currency_category_value);
    this.formGroup.controls['currency_category'].setValue(this.data.res.travel_summary.currency_category);
    this.formGroup.controls['charged_to_category'].setValue(this.data.res.travel_summary.charged_to_category);
    this.formGroup.controls['inclusive_date_from'].setValue(this.data.res.travel_summary.inclusive_date_from);
    this.formGroup.controls['inclusive_date_to'].setValue(this.data.res.travel_summary.inclusive_date_to);
    this.formGroup.controls['location'].setValue(this.data.res.travel_summary.location);
    this.formGroup.controls['nature'].setValue(this.data.res.travel_summary.nature);
    this.formGroup.controls['travel_type'].setValue(this.data.res.travel_summary.travel_type);
    this.formGroup.controls['others'].setValue(this.data.res.travel_summary.others);

    // Version 1.5
    this.formGroup.controls['travel_request_type'].setValue(this.data.res.travel_request_type);
    this.formGroup.controls['employee_name'].setValue(this.data.res.employee_name);
    this.formGroup.controls['employee_id'].setValue(this.data.res.employee_id);
    this.formGroup.controls['level'].setValue(this.data.res.level);
    this.formGroup.controls['area_assigned'].setValue(this.data.res.area_assigned);
    
    this.formGroup.controls['travel_type'].setValue(this.data.res.travel_summary.travel_type);
    this.formGroup.controls['booking_type'].setValue(this.data.res.travel_summary.booking_type);

    this.travel.formGroup = this.formGroup;
    let purposeOption = this.data.res.travel_summary.purpose.split("|");
    this.formGroup.controls['purpose'].setValue(purposeOption[0]);
    this.data.isOther = false;
    if (purposeOption[0] == "OTHERS") {
      this.isOther = true;
      this.data.isOther = true;
      //this.formGroup.controls['others'].setValue(purposeOption[1]);
    }

    //itineraries 
    if (this.data.res.travel_itineraries[0]) {
      this.itineraryId = this.data.res.travel_itineraries[0].id;
      this.formGroup.controls['itinerary_date'].setValue(this.data.res.travel_itineraries[0].itinerary_date);
      this.formGroup.controls['accommodation_cost'].setValue(this.data.res.travel_itineraries[0].accommodation_cost);
      this.formGroup.controls['booked_by'].setValue(this.data.res.travel_itineraries[0].booked_by);
      this.formGroup.controls['bill_to'].setValue(this.data.res.travel_itineraries[0].bill_to);
      this.formGroup.controls['representation'].setValue(this.data.res.travel_itineraries[0].representation);
      this.formGroup.controls['miscellaneous'].setValue(this.data.res.travel_itineraries[0].miscellaneous);
      this.formGroup.controls['per_diem'].setValue(this.data.res.travel_itineraries[0].per_diem);
      this.formGroup.controls['is_lunch'].setValue(this.data.res.travel_itineraries[0].is_lunch);
      this.formGroup.controls['is_breakfast'].setValue(this.data.res.travel_itineraries[0].is_breakfast);
      this.formGroup.controls['is_dinner'].setValue(this.data.res.travel_itineraries[0].is_dinner);
      this.formGroup.controls['meal'].setValue(this.data.res.travel_itineraries[0].meal);
      this.itineraries = this.data.res.travel_itineraries[0].travel_itinerary_details;
      this.travel.summary_list = this.data.res.travel_itineraries[0].travel_itinerary_details;
      this.formGroup.controls['travel_itinerary_details'].setValue(this.travel.summary_list);
    }

    this.expensesList  = this.functionService.loopRangeDate(
      [this.data.res.travel_summary.inclusive_date_from,this.data.res.travel_summary.inclusive_date_to],
      this.data.res.travel_itineraries
    );
    
    if (this.data.res.travel_summary.currency_category == 3) {
      this.isCurrency = true;
    }
    
    if (this.data.res.travel_summary.charged_to_category == 3) {
      this.isCharged = true;
    }

    this.labelName = this.statusOption[this.data.res.status_id];

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.position = {
      'top': '0',
      'right': '0',
    }
    this.dialogConfig.width = '800px';
    this.dialogConfig.height = '100%';
    this.dialogConfig.disableClose = true;
    this.dialogConfig.panelClass = 'mat-dialog';
    this.dialogConfig.backdropClass = 'mat-dialog-backdrop';

    this.travel.disableForm();
    this.travel.itineraries = this.data.res.travel_itineraries;
    this.travel.getTotal();

    if (this.travel.special_approvers.special_instruction_approvers_final) {
      this.travel.special_approvers.special_instruction_approvers_final.forEach(element =>{
        if (element.approver_id == this._user.id) {
          this.isSpecialApprover = true;
        }
      });
    }

    if (this.travel.special_approvers.special_instruction_approvers_first) {
      this.travel.special_approvers.special_instruction_approvers_first.forEach(element =>{
        if (element.approver_id == this._user.id) {
          this.isFirstSpecialApprover = true;
        }
      });
    }

    if (this._user.is_final_approver == 1 && this.travel.first_approved_by != this._user.id) {
      this.isNotFirstApprover = true;
    }

    if (this._user.is_final_approver != 1) {
      this.isFirstApprover = true;
    }
  }

  closeOnClick() {
    this.dialogRef.close(true);
  }

  keyvalid(e,max){
    if (e.target.value >= Math.round(max.order_qty)) {
      this.qty[max.id].qty_to_ship = max.order_qty;
    }
  }

  keypressValidateNumber(e,max) {
    const pattern = new RegExp(/\d/); // '\d'
    let maxlen = ""+Math.round(max)+"";
    if (e.target.value >= Math.round(max)) {
      return false;
    }
    if (e.target.value.length >= maxlen.length) {
      return false;
    }

    return pattern.test(e.key);
  }

  update(e){
    if (e == 1) {
      this.loading = true;
      let data = {
        status: 'Approved',
      }  
      this.travelService.approverUpdateStatus(this.data.res.id,data).subscribe(res=>{
        this.loading = false;
        this.dialog.open(NotifyboxComponent , {
          disableClose:true,
          data: {
            reload:false,
            label:'Ok',
            isclose:true,
            message: res['message']
          }
        }).afterClosed().subscribe(result => {
          if (result) {
            this.dialogRef.close(true);
          }
        });
      },(err =>{
        this.loading = false;
        this.travel.setErrors(err.error.errors);
        this.travel.triggerErrors(err.error.errors);
      }));
    } else {
      this.dialogConfig.width = '800px';
      this.dialogConfig.data = {
        id: this.data.res.id,
        status: e,
        status_id: this.data.res.status_id
      }
      let dialogRef = this.dialog.open(TravelAuthorizationCancelComponent, this.dialogConfig);
      dialogRef.afterClosed().subscribe(result => {
        if (result != '') {
         this.closeOnClick();
        }
      });
    }

  }

    /**
   * View itinerary Details Modal
   * @param res 
   */
  viewItinerary(res,i) {
    this.dialogConfig.width = '100vw';
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.data = {
      res,
      list:this.travel.booking_details_list,
      mode: 1,
      displayEdit: this.show,
      auth_id: this.data.res.travel_summary.travel_request_id,
      book_id: res.id,
      is_draft: (this.data.res.status_id == 0)? true : false
    }
    let dialogRef = this.dialog.open(TravelItineraryViewComponent, this.dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.travel.totalPortFee = 0;
        this.travel.totalLodging = 0;
        this.travel.totalDiem = 0;
        this.travel.totalMeal = 0;
        this.travel.totalRepre = 0;
        this.travel.totalMisc = 0;
        this.travel.totalExpenses = 0;
        this.travel.totalTranspo = 0;
        this.expensesList[i] = result;
        this.travel.itineraries[i] = result;
        this.travel.getTotal();
      }
    });
  }

  /**
   * Manual change tab
   * @param e tab-index
   */
  next(e){
    this.selectedIndex=e;
  }

  back(e){
    this.selectedIndex=e;
  }
  
  displayCurrency(e) {
    this.isCurrency = false;
    if (this.data.res.travel_summary.currency_category == 3) {
      this.isCurrency = true;
    }
    this.formGroup.get('currency_category').valueChanges.subscribe(value => { 
      this.isCurrency = true;
      if (value == 3) {
        this.isCurrency = true;
      }
    })
  }

  /**
   * Display other supplier
   * @param e  e = 3 get value for supplier
   */
  displayCharge(e) {
    this.isCharged = false;
    if (this.data.res.travel_summary.charged_to_category == 3) {
      this.isCharged = true;
    }
    this.formGroup.get('charged_to_category').valueChanges.subscribe(value => { 
      this.isCharged = false;
      if (value == 3) {
        this.isCharged = true;
      }
    })
  }

}